import { render, staticRenderFns } from "./category-detail.vue?vue&type=template&id=f19dc2f0&scoped=true&"
import script from "./category-detail.vue?vue&type=script&lang=js&"
export * from "./category-detail.vue?vue&type=script&lang=js&"
import style0 from "./category-detail.vue?vue&type=style&index=0&id=f19dc2f0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19dc2f0",
  null
  
)

export default component.exports